import { actions as UserActions } from 'store/user';

export default store => {
  return {
    startSession: () => {
      store.dispatch(UserActions.sessionStart());
    },
    refreshSessionIfNeeded: () => {
      const xTokenExpiresTime = store.getState()?.user?.xTokenExpires;
      if (Date.now() > xTokenExpiresTime) {
        store.dispatch(UserActions.refreshToken());
      }
    }
  };
};
